export default "__VITE_ASSET__BGrpisiA__"